import { Tool } from '../../types';

export const socialMediaTools: Tool[] = [
  {
    id: 'buffer',
    name: 'Buffer',
    category: 'Social Media Management',
    description: 'Social media scheduling and analytics platform',
    pricing: ['free', 'low', 'medium'],
    features: ['ease-of-use', 'mobile', 'automation'],
    bestFor: ['freelancer', 'small-business'],
    compatibleWith: ['content-creator', 'agency', 'service-business'],
    goals: ['improve-marketing', 'build-brand'],
    industries: ['marketing', 'creative', 'retail'],
    website: 'https://buffer.com',
    imageUrl: 'https://logo.clearbit.com/buffer.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner'],
    minTeamSize: 'solo'
  },
  {
    id: 'hootsuite',
    name: 'Hootsuite',
    category: 'Social Media Management',
    description: 'Comprehensive social media management platform',
    pricing: ['medium', 'high'],
    features: ['automation', 'integrations', 'mobile'],
    bestFor: ['small-business', 'agency'],
    compatibleWith: ['content-creator', 'service-business'],
    goals: ['improve-marketing', 'build-brand'],
    industries: ['marketing', 'retail', 'creative'],
    website: 'https://hootsuite.com',
    imageUrl: 'https://logo.clearbit.com/hootsuite.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'later',
    name: 'Later',
    category: 'Social Media Management',
    description: 'Visual social media planning and scheduling',
    pricing: ['free', 'low', 'medium'],
    features: ['ease-of-use', 'mobile', 'integrations'],
    bestFor: ['freelancer', 'small-business'],
    compatibleWith: ['content-creator', 'e-commerce'],
    goals: ['improve-marketing', 'build-brand'],
    industries: ['retail', 'creative', 'marketing'],
    website: 'https://later.com',
    imageUrl: 'https://logo.clearbit.com/later.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  }
];